module.exports = __webpack_public_path__ + "img/traveller_stopped.f6c1e7c0.svg";